import { aAppModel } from '../builders/app-model.builder';
import { isWorker } from './utils';
export function getHackyWindowProps() {
    return (!isWorker() && window.__APP_MODEL__) || aAppModel();
}
//# sourceMappingURL=getHackyWindowProps.js.map